import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppSelector, useAppDispatch } from "@app/hooks";
import { object, string } from "yup";
import { DefaultErrorMessages } from "../../../../../common/helpers/formValidationHelper";
import { LInputField } from "../../../../../common/components/LInputField";
import { LBtn } from "../../../../../common/components/LBtn";
import { useModal } from "../../../../../services/ModalContext";
import { useApi } from "../../../../../services/useApi";
import { updateOrganization as updateOrganizationAction } from "../../../../../common/store/organizationSlice";

const formSchema = object({
    orgName: string().required(DefaultErrorMessages.required)
});

interface EditOrganization {
    orgName: string;
}

export const EditAccountDetailModal = (): JSX.Element => {
    const organization = useAppSelector((x) => x.organization);
    const dispatch = useAppDispatch();

    const validateMethods = useForm<EditOrganization>({
        resolver: yupResolver(formSchema)
    });

    const { updateOrganization, loading } = useApi();
    const { closeModal } = useModal();

    const formSubmitHandler: SubmitHandler<EditOrganization> = async (org: EditOrganization) => {
        await updateOrganization(organization.id!, org.orgName);

        dispatch(updateOrganizationAction({ ...organization, orgName: org.orgName }));

        closeModal();
    };

    return (
        <FormProvider {...validateMethods}>
            <form onSubmit={validateMethods.handleSubmit(formSubmitHandler)}>
                <LInputField
                    label="Organization name"
                    inputName="orgName"
                    placeholder="e.g. Sample Hospital"
                    defaultValue={organization?.orgName}
                />
                <div className="divider" />
                <div className="pt-2">
                    <div className="columns">
                        <div className="column" />
                        <div className="column is-4">
                            <LBtn variation="outline" fullWidth onClick={closeModal}>
                                Cancel
                            </LBtn>
                        </div>
                        <div className="column is-1" />
                        <div className="column is-4">
                            <LBtn fullWidth type="submit" loading={loading}>
                                Update
                            </LBtn>
                        </div>
                        <div className="column" />
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};
